export enum StartupMessageClassification {
	None,
	Startup,
	NewFeature,
	PageCarousel,
}
